__webpack_require__.p = "/web-receipt/";